<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<div v-if="properties.uid">
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold">*</span></label>
							<input type="email" class="form-control" :name="form.id" v-model.lazy="orderData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-else-if="form.division === 'O'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == orderData[form.id]">{{form1.codeName}}</span></p>
							<p class="mg-b-0 text-left" v-else>{{orderData[form.id]}}</p>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="orderData[form.id]" class="custom-control-input" :checked="form1.codeCode == orderData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left">{{orderData[form.id]}}</p>
						</div>
					</ul>
				</div>
				<div v-else>
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold">*</span></label>
							<input type="email" class="form-control" :name="form.id" v-model.lazy="orderData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="orderData[form.id]" class="custom-control-input" :checked="form1.codeCode == orderData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
				</div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">Detail</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} Detail</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="confirmData()"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Confirm</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData(true)" ><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-if="properties.uid" ><feather type="delete" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goPage()"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>List</button>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item"><a class="nav-link active" id="experiment-tab" data-toggle="tab" href="#experiment" role="tab" aria-controls="experiment" aria-selected="true" @click="this.rendertab">Order</a></li>
							<li class="nav-item"><a class="nav-link" id="samples-tab" data-toggle="tab" href="#samples" role="tab" aria-controls="samples" aria-selected="false">Samples</a></li>
						</ul>
					</div>
					<div class="card card-body">
						<div class="tab-content mg-t-20" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="experiment" role="tabpanel" aria-labelledby="experiment-tab">
								<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="check" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>all checked</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</a>

								</div>
								<ul class="nav nav-line" id="myTab5" role="tablist">
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
								<hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table" ref="sheet" :afterChange="changeData"></hot-table>
							</div><!-- tab -->
							<div class="tab-pane fade" id="samples" role="tabpanel" aria-labelledby="samples-tab">
								<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" v-if="reOrderButtons" data-toggle="modal" data-animation="effect-flip-horizontal" @click="cancelReOrder('cancel')"><feather type="delete" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>발주취소</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" v-if="reOrderButtons" data-toggle="modal" data-animation="effect-flip-horizontal" @click="cancelReOrder('disposal')"><feather type="trash-2" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>폐기요청</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="sampleAddColumn"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add</a>
								</div>
								<ul class="nav nav-line" id="myTab5" role="tablist">
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="(tabHeader.length - 2) === i">
									<a
										class="nav-link active"
										@click="classifyWorkChange(form.id)"
										:id="form.id"
										data-toggle="tab"
										href="#"
										role="tab"
										aria-controls="home"
										aria-selected="true"
									>{{form.menuName}}</a>
									</li>
									<li class="nav-item" v-else-if="(tabHeader.length - 1) === i">
									<a
										class="nav-link"
										@click="classifyWorkChange(form.id)"
										:id="form.id"
										data-toggle="tab"
										href="#"
										role="tab"
										aria-controls="profile"
										aria-selected="false"
									>Re-Order</a>
									</li>
								</ul>
								<section>
									<b-table id='preTable' :data="isEmpty ? [] : preData" :checked-rows.sync="checkedRows" ref="table" hoverable striped checkable detailed detail-key="id" :show-detail-icon="false" :opened-detailed="defaultOpenedDetails" @details-open="(row, index) => closeAllOtherToggle(row, index)">
										<template slot-scope="props">
											<b-table-column v-for="(form, i) in preHeader" v-if="Number(i) == 0" :key="form.id" :custom-key="form.id" field="no" :label="'No'" centered>{{props.row.no}}</b-table-column>
											<b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
												<a href='#' @click='toggle(props.row)' :id="props.index"> {{ props.row[form.columnCode] }} </a>
											</b-table-column>
											<b-table-column v-else :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>{{props.row[form.columnCode]}}</b-table-column>
										</template>
										<template slot="empty">
											<section class="section">
												<div class="content has-text-grey has-text-centered">
												<p>Nothing here.</p>
												</div>
											</section>
											</template>
											<template slot="detail" slot-scope="props">
											<ul class="nav nav-line" id="myTab5" role="tablist"> <!-- 이전 단계 그룹 내 단계별 검체 정보 확인 tab -->
												<li class="nav-item" v-for="(form, i) in tabHeader" v-if="form.id == re_orderId">
													<a class="nav-link active" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a>
												</li>
												<li class="nav-item" v-else-if="re_orderId.length == 0 && i == 0">
													<a class="nav-link active" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
												</li>
												<li class="nav-item" v-else-if="(tabHeader.length - 2) >= i">
													<a class="nav-link" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
												</li>
											</ul>
											<b-table id="preSampleTable" :columns="preSampleHeader" :data="isEmpty ? [] : preSampleData" :checked-rows.sync="sampleCheckedRows" ref="sampleTable" hoverable striped checkable></b-table>
											</template>
									</b-table>
									<div class='d-none'><b-table id='preSampleTable' ref="sampleTable"></b-table></div>
								</section>
							</div><!-- tab -->
						</div>
					</div><!-- card -->
				</div>
			</div>
		</div>
	</div> <!-- this body end -->
</template>
<script>
	// 에디트 기능 handsontable 사용 시 임포트
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	// 공통 함수 관리 파일 임포트
	import common from '@/views/Common/common.js';
	// 멀티 드래그 앤 드롭 임포트
	import Sortable, {Swap} from 'sortablejs';
	Sortable.mount(new Swap());
	// Header의 메뉴 정보 호출을 위한 bus event
	import {bus} from '../../main';
	import Approval from "@/views/Common/Approval";
	import Chat from "@/views/Common/Chat";

	// 이미지 드래거블
	import { Draggable } from 'draggable-vue-directive'
	export default {
		name: 'Detail',
		props: ['properties'],
		directives: {
            Draggable,
        },
		data(){
			return{
				mainName:'',
				subName:'',
				menuData:[], // header.vue data

				mid:'', // menu list id
				msid:'', // menu sheet id
				uid:'', // sheet id
				ssid:'', // sample list id
				rowNum:'', // sample group row number

				/*  input Form */
				orderHeader:[], // 입력 값 header column
				inputSearchForms:[], // 입력 input form
				dateSearchForms:[], // 입력 date form
				checkboxSearchForms:[], // 입력 radio form

				/* Experiment 정보 Form Value */
				orderData: [], // 실험 정보 확인
				dafaultOrderData: [], // 화면에 처음 접속 시 유지된 실험 정보 (데이터 저장 시 수정 사항 체크에 필요)

				/* tab Header */
				tabHeader:[],
				// sheetCoulumns:[],

				/* 이전 단계 Sample 정보 */
				preHeader:[],
				preData:[],
				preDefaultData:[],
				preSampleHeader:[],
				preSampleData:[],
				preDefaultSampleData:[],
				preDetail:[],
				checkedRows:[], // 그룹 체크 row 확인
				checkedRowData:[], // add 이전 체크 sample row 확인
				sampleCheckedRows:[], // sample 체크 row 확인
				isEmpty: false,
				addData:[],
				defaultOpenedDetails:[],

				/* Sample Form */
				sampleHeader:[], // Experiment Sample Header
				sampleData:[], // Experiment Sample list data
				// sampleData:[1,2,3,4,5,6,7,8,9,10],
				
				dafaultSampleData:[], // 화면에 처음 접속 시 유지된 Sample 정보 (데이터 저장 시 수정 사항 체크에 필요)
				//sampleChangeData:[], // Sample의 변경 정보
				boolChange: false, // 데이터 변경 유무 확인
				preDetail:[],

				/* Loading */
				isLoading: false,
				isFullPage: true,

				isCheckAll: false,

				excelHeader:{},
				excelData:[],
				json_meta: [[{'key': 'charset','value': 'utf-8'}]],

				/* file upload */
				formData:'',
				uploadFlag: false,
				imgData:[],
				imgId: [],

				/*idx */
				maxDivIdx:[],
				maxReIdx:[],
				maxIdx: [],

				re_orderId: '',
				reOrderData: [],
				reOrderButtons: false
			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			this.openLoading();
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyHeader();
				this.classifySampleHeader();
				this.classifyData();
				this.classifyPreDefaultData();
			});
		},
		mounted() {
		},
		components: {
			HotTable,
			Approval,
			Chat,
		},
		methods: {
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.msid = data[2];
				this.orderHeader = data[3];
				this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];
				for(let i in this.orderHeader){
					if(this.orderHeader[i].columnType == "LIST"){
						if(this.orderHeader[i].columnAttr =='statecode'){
							this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':this.orderHeader[i].code, 'id':this.orderHeader[i].columnCode ,'division':'O'});
						}else{
							this.checkboxSearchForms.push({'name':this.orderHeader[i].columnName, 'id':this.orderHeader[i].columnCode, 'value':this.orderHeader[i].code, 'division':this.orderHeader[i].columnDivision});
						}
					}else if(this.orderHeader[i].columnType == "DATE"){
						if(!common.isNull(this.properties.uid)){
							this.dateSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
						}
					}else if(this.orderHeader[i].columnType == "COUNT"){
						
					} else {
						if (this.orderHeader[i].columnName == 'No') {
						} else {
							if (!common.isNull(this.properties.uid)) {
								this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
							} else {
								if(this.orderHeader[i].columnDivision == 'C'){
									this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
								}
							}
						}
					}
				}
				this.classifyPreHeader();
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData(){
				var thisData = [];
				var sampleData = [];
				if(!common.isNull(this.properties.uid)){
					var params = [];
					params = {'ssid' : this.ssid};
					params['uid'] = this.properties.uid;
					var request = {params : params}
					await this.$axios.get(this.$apiHost + '/orders/detail', request)
					.then(res=>{
						this.orderData = res.data;
					}).catch(err=>{console.log(err)});
					sampleData = common.makeData(this.orderData.samples, 0);
				
					this.excelData = common.makeData(this.orderData.samples, 1);
					for(let i in sampleData){
						this.maxDivIdx.push(sampleData[i].maxdividx);
						this.maxReIdx.push(sampleData[i].maxreidx);
						sampleData[i].No = Number(i) + 1;
						thisData = thisData.concat(false);
						
						for(let j in this.sampleHeader){
							if (j == 0) {
								thisData = thisData.concat(sampleData[i].No);
								thisData = thisData.concat(sampleData[i].sampleId);
							}
							if(this.sampleHeader[j].columnType === 'LIST'){
								if(this.sampleHeader[j].mid != this.properties.mid){
									if(!common.isNull(sampleData[i][this.sampleHeader[j].columnCode])){
										for(let k in this.sampleHeader[j].code){
											if(sampleData[i][this.sampleHeader[j].columnCode] === this.sampleHeader[j].code[k].codeCode){
												thisData = thisData.concat(this.sampleHeader[j].code[k].codeName);
											}
										}
									}else{
										thisData = thisData.concat('');
									}
								}else{
									thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
									
								}
							}else{
								if (this.sampleHeader[j].columnAttr === 'receptionno') thisData = thisData.concat("<a href='#modal5' data-toggle='modal'>"+sampleData[i][this.sampleHeader[j].columnCode]+"</a>");
								else thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
							}
						}
					
						thisData = thisData.concat(sampleData[i].duid);

						this.sampleData.push(thisData);
						this.dafaultSampleData.push(thisData);

						thisData = [];
					}
				}
				this.rendertab();
				this.isLoading = false;
			},
			/*
			* Previous Group Header
			*/
			async classifyPreHeader(){
				// let mid  = common.preMid(this.properties.mid, this.menuData);
				let mid = '';
				if(common.isNull(this.re_orderId)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = this.properties.mid;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}else{
						if(this.re_orderId.length > 0) mid = this.re_orderId;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}
				}else{
					if(this.re_orderId === this.properties.mid) mid = this.properties.mid;
					else mid = common.preMid(this.properties.mid, this.menuData);
				}
				this.preHeader = [];
				this.preHeader = common.menuHeader(mid, this.menuData)[3];
				this.classifyPreData();
			},
			/*
			* Previous Group Data
			*/
			async classifyPreData(){
				// let mid  = common.preMid(this.properties.mid, this.menuData);
				this.preData = [];
				this.preData = common.makeData(this.preDefaultData, 1, this.addData); // {data, (0: code, 1:name), checkdata}
			},
			/*
			* Previous Sample Header
			*/
			async classifyPreSampleHeader(){
				var preSampleHeader = [];
				let mid = '';
				if(!common.isNull(event.target.id)) mid = event.target.id.replace(/[0-9]/g, "");
				else mid = common.preMid(this.properties.mid, this.menuData);
				if(mid.length === 0){
					if(common.isNull(this.re_orderId)) mid = common.preMid(this.properties.mid, this.menuData);
					else mid = this.re_orderId;
				}else{
 					mid = event.target.id;
				}
				this.preSampleHeader = [];
				if(common.isNull(this.re_orderId)) preSampleHeader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
				else preSampleHeader = common.makeHeader(this.re_orderId, this.menuData,2)[1];
				for(let i in preSampleHeader){
					if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
					if(mid === preSampleHeader[i].mid) {
						if (preSampleHeader[i].columnName != 'Order Result') {
							this.preSampleHeader.push({'field':preSampleHeader[i].columnCode, 'label':preSampleHeader[i].columnName, 'centered':true});
						}
					}
					if(common.isNull(preSampleHeader[i].mid)) this.preSampleHeader.push({'field':preSampleHeader[i].columnCode, 'label':preSampleHeader[i].columnName, 'centered':true});
				}

				this.classifyPreSampleData();
			},
			/*
			* Previous Sample Data
			*/
			async classifyPreSampleData(){
				let rowNum = event.target.id.replace(/[0-9]/g, "");
				if(rowNum.length === 0){
					if(!common.isNull(event.target.id)){
						rowNum = event.target.id;
						this.rowNum = rowNum;
					}else{
						rowNum = this.rowNum;
					}
				}else{
					rowNum = this.rowNum;
				}

				this.preDefaultSampleData = common.thisZeroDataSplice(this.preDefaultSampleData);

				this.preSampleData = [];
				this.preSampleData = common.makeData(this.preDefaultSampleData[rowNum], 1, this.addData); // {data, (0: code, 1:name), checkdata}
				for (let i in this.preSampleData) { //샘플탭 샘플 상세보기에 넘버링 값 추가
					this.preSampleData[i].no = Number(i) + 1;
				}
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[rowNum])){
					this.sampleCheckedRows = this.preSampleData;
				}else{
					this.sampleCheckedRows = [];
				}
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifyPreDefaultData(){
				let mid = '';
				let reOrderFlag = false;
				if(common.isNull(this.re_orderId)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = common.nextMid(this.properties.mid, this.menuData);
						else mid = this.properties.mid;
					}else{
						if(this.re_orderId.length > 0) mid = this.re_orderId;
						else mid = this.properties.mid;
					}
				}else{
					if(this.re_orderId === this.properties.mid) { 
						reOrderFlag = true;
						mid = this.properties.mid;
					}
					else mid = this.properties.mid;
				}

				this.preDefaultData = [];
				this.preSampleData = [];
				this.preDefaultSampleData = [];
				this.defaultOpenedDetails = [];
				var params = []; 
				params = {'mid' : mid,
						  'reOrderFlag' : reOrderFlag};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + '/orders/prestep', request)
				.then(res=>{
                    console.log(res.data);
					for(let i in res.data){
						res.data[i].no = Number(i)+1;
						this.preDefaultData.push(res.data[i]);
						for(let j in res.data[i].samples){
							this.preDetail[res.data[i].samples[j].sampleId] = res.data[i].samples[j].duid;
							res.data[i].samples[j].gid = res.data[i].id;
						}
						this.preDefaultSampleData.push(res.data[i].samples);
					}
				}).catch(err=>{console.log(err)});
                
				// 이전 단계 (실험 대상), 현재 단계 (재실험 대상)에 배열에 데이터 세팅
				// if(mid === this.properties.mid){
				// 	// 이전 단계 (실험 대상 조화 결과가 PASS 만 조회)
				// 	this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, '');
				// 	this.preDefaultData = common.remove_default(this.preDefaultData);
				// }
				// }else{
				// 	// 현재 단계 (재실험 대상 조회 결과가 PASS 가 아닌것 조회)
				// 	this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, 'R');
				// 	this.preDefaultData = common.remove_default(this.preDefaultData);
				// }

				this.preSetting();
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifySampleHeader(){
				let thisMid = event.target.id;
				if(common.isNull(thisMid)) thisMid = this.properties.mid;
				let data = common.makeHeader(this.properties.mid,this.menuData,2);
				this.ssid = data[0];
				this.sampleHeader = data[1];
				// this.sheetCoulumns = this.sampleHeader.filter(item => item.mid == thisMid);
				
				this.sheetSettings.hiddenColumns.columns = [2]
				this.$refs.sheet.settings.columns = [];
				this.$refs.sheet.settings.colHeaders = [];
				let idx = 3; // column hidden 을 위한 값
				for(let i in this.sampleHeader){
					if(Number(i) === 0){
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("");
						this.$refs.sheet.settings.columns.push({sampleData:'checkbox', type:'checkbox', width:'20px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('No');
						this.$refs.sheet.settings.columns.push({sampleData:'No', type:'text', readOnly: true, width:'30px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('id');
						this.$refs.sheet.settings.columns.push({sampleData:'id', type:'text', width:'20px', readOnly: true});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if(this.sampleHeader[i].columnAttr === 'receptionno') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, renderer: 'html', readOnly: true});
						else this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
					}else{
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if(this.sampleHeader[i].columnType === 'LIST'){
							var source = [];
							for(let j in this.sampleHeader[i].code){
								source.push({id:this.sampleHeader[i].code[j].codeCode, name:this.sampleHeader[i].code[j].codeName});
							}
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'key-value', filter:false, source: source, keyProperty: 'id', valueProperty: 'name',readOnly: true});
							}
						}else if(this.sampleHeader[i].columnType === 'DATE'){
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'date', dateFormat:'YYYY-MM-DD'});
							}
						}else{
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}else{
									if(this.sampleHeader[i].columnAttr === 'sampleid') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								if (this.sampleHeader[i].columnDivision == 'O') {
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
								} else {
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text'});
								}
							}
						}
					} 
					if(thisMid != this.sampleHeader[i].mid){
						if(!common.isNull(this.sampleHeader[i].mid)){
							// 실험 내 화면에서 탭 선택 시 Handsontable column 숨기기 할 것
							this.sheetSettings.hiddenColumns.columns.push((Number(i)+Number(idx)));
						}
					}
					this.excelHeader[this.sampleHeader[i].columnName] = this.sampleHeader[i].columnCode;
				}
				this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('did');
				this.$refs.sheet.settings.columns.push({sampleData:'detailId', type:'text', readOnly: true});
				
				this.sheetSettings.hiddenColumns.columns.push(Number(this.$refs.sheet.settings.columns.length)-1);

				this.rendertab();
			},
			/*
			* List page Move (리스트 목록 페이지 이동)
			*/
			goPage() {
				if(this.boolChange){
					var result = confirm('You have changed data. Would you like to leave?');
					if(result){
						sessionStorage.removeItem('uid');
						this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
					}else{
						return false;
					}
				}else{
					this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
				}
			},
			/*
			* buefy 테이블 현재 토글 디테일 창 열기
			*/
			toggle(row) {
				// 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
				if(row.id === this.defaultOpenedDetails[0]){
					this.defaultOpenedDetails = []
				}else{ // 토글 창이 닫혀있을때 실행
					this.$refs.table.toggleDetails(row);
					this.defaultOpenedDetails = [row.id]
				}
				this.preSampleSetting();
			},
			/*
			* buefy 테이블 이전 토글 디테일 창 닫기 b-table 설정에 toggle 창 실행 시 이전 창은 닫히고 현재 선택 창이 열리도록 설정 되어 있음
			*/
			closeAllOtherToggle(row, index) {
				this.defaultOpenedDetails = []
				this.defaultOpenedDetails = [row.id]
			},
			/*
			* handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
			*/
			rendertab() {
				// height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
				// hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
				if(this.sampleData.length > 0){
					let height = (((this.$refs.sheet.hotInstance.countRows()) * 34)+50)+'px';
					this.$refs.sheet.hotInstance.updateSettings({height:height})
					// Handsontable 문제로 화면이 전환될때 기존에 출력 화면 위치를 잃어 버림, render를 한번 사용하면 화면에 출력될 디자인만 그린다
					// 출력 위치까지 잡으려면 render를 한번 더 사용해야한다. 연속으로 render를 하면 되지 않아서 setTimeout으로 약간의 시간차를 두고 render 실행한다
					// 하지만 tab를 사용할 때 데이터가 있다면 4줄정도만 나오게 된다. 이부분 때문에 동일한 render를 무려 8번이나 실행했다.
					// 그렇다고 setTimeout의 시간을 늘려 render 시간을 해주는건 헛수고 이다.
					// 짧은 시간 반복 횟수가 중요 함 (10*20 timeout이 가장 적절하며, 20이하는 render 안됨)
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					this.$refs.sheet.hotInstance.render();
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					this.$refs.sheet.hotInstance.render();
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					this.$refs.sheet.hotInstance.render();
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					this.$refs.sheet.hotInstance.render();
				}else{
					setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
					this.$refs.sheet.hotInstance.render();
				}
			},
			/*
			* Sample Add Column
			*/
			async sampleAddColumn(){
				this.openLoading();
				let insert_row = [];
				let remove_row = [];
				if(this.addData.length > 0){
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
						this.addData.push(a);
					});
					common.a_overlap_c(this.addData);
					this.addData.forEach(a=>{
						insert_row.some((c,d)=>{
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									remove_row.push(d);
									return true;
								}
							}else{
								if(a.sampleId === c.sampleId){
									remove_row.push(d);
									return true;
								}
							}
						});
					});
					remove_row.sort((a,b)=>{ return b - a;});
					remove_row.forEach(a=>{
						insert_row.splice(a,1);
					});
				}else{
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
						this.addData.push(a);
					});
				}

				// 위에서 만든 insert_row를 sampleHeader(Experiment 테이블 헤더) 순서에 맞춰 Handsontable에 데이터를 넣어준다
				// ref는 검색을 통하면 어떠한 기능인지 확인 가능
				// Handsontable 은 sheet라는 배열에 담겨 있다. 실제로 vue 에서 get, set 할수 있는 Function은 hotInstance에 있다 (Handsontable API에서 말하는 core 부분이 hotInstance 이다.)
				let scode = common.find_sid_code(this.sampleHeader, 'sampleid');
				let divcode = common.find_sid_code(this.sampleHeader, 'divisionidx');
				let recode = common.find_sid_code(this.sampleHeader, 'reexpidx');

				let reOrderCode = common.find_codeCode_name(this.sampleHeader,'result', '재발송');

				insert_row.forEach((a,b)=>{
					let sampleData = [];
					sampleData.push(false);
					sampleData.push(b+1);
					sampleData.push(a.sampleId);
					this.sampleHeader.forEach((c,d)=>{

					if (c.columnAttr === 'divisionidx') { //디비전 초기값 
						sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
					} else if (c.columnAttr === 'reexpidx') {
						sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
					} else if (c.columnName === 'Order Result' && this.reOrderButtons) { //this.reOrderButtons : reordertab누른 상태
						sampleData.push(reOrderCode);
					} else {
						sampleData.push(a[c.columnCode]);
					}
               });
               
					sampleData.push(a.detailId);
					this.sampleData.push(sampleData);
				})

				// preSampleSetting 를 실행하는 이유는 데이터가 입력 되고 samples(buefy table)을 다시 render 하기 위하여 실행
				this.preSetting();
				this.preSampleSetting();
				// this.isLoading = false;
			},
			/*
				발주취소,폐기요청		
			*/
			async cancelReOrder(evt) {
				this.openLoading();

				const sIds = [];
				let event = '';
				const uid = this.properties.uid;
				const mid = this.properties.mid
				const msid = this.msid;

				if (evt === 'cancel') {
					event = common.find_codeCode_name(this.sampleHeader, 'result', '발주 취소');
				} else {
					event = common.find_codeCode_name(this.sampleHeader, 'result', '폐기 요청');
				}

				for (let i in this.checkedRowData) {
					sIds.push(this.checkedRowData[i].sampleId);
				}
				this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/cancel', 
					{uid, sIds,mid, msid, event}).then((res) => {
					if (res.data) {
						this.classifyWorkChange(mid);
					}
				});;
			},
			/*
			* confirm Data page Move
			*/
			async confirmData() {
				if (this.properties.uid) {
					this.openLoading();
					var result = confirm('Are you sure you want to confirm?');
					const uid = this.properties.uid;
					const mid = this.properties.mid
					const msid = this.msid;
					let colCnt = this.$refs.sheet.hotInstance.countRows();
					let detailIds = [];
					let sIds= [];
					for(let i=0; i < Number(colCnt); i++){
						detailIds.push(this.$refs.sheet.hotInstance.getDataAtCell(i,this.sampleData[i].length-1));
					}
					for(let i in this.sampleData){
						for(let j in this.sampleData[i]){
							if(j == 2){
								sIds.push(this.sampleData[i][j]);
							}
						}		
					}
					if (result) {
						this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/confirm', {
						uid, sIds,mid, msid
						})
						.then((res) => {
							sessionStorage.setItem('uid',uid);
							this.isLoading = false;
							this.$router.push({name:'orders_completion',params:{mid:this.properties.mid,uid:uid,type:'detail'}});
						});
					} else {
						this.isLoading = false;
						return false;
					}
				} else {
					var result = confirm('Are you sure you want to confirm?');
					if (result) {
						this.createData(false);
					}
				}
         	},
			 /*
         * Experiment & Samples Create data
         */
         async createData(evt){
            this.openLoading();
            var params = [];
            var sendKey = '';
            var sendValue = '';
            var changeData = [];
            var thisData = [];
			let wellList = [];
            var sidx = 0;	
			var myNum = 2
          
            for(let i in this.sampleData){
               
               for(let j in this.sampleData[i]){
                  if(j == 2){
                     // set sample : detail id 
                     changeData.sid = this.sampleData[i][j];
                  }
                  if(j > 2){
                     if (common.isNull(this.sampleHeader[Number(j-3)])) {
                        changeData.detailId = this.sampleData[i][j];
                     } else {
                        changeData[this.sampleHeader[Number(j-3)].columnCode] = this.sampleData[i][j];
                     }
                  } 
               }
               thisData.push($.extend(true, {}, changeData));

								
					// dArr.push($.extend(true, {}, dobj));

               changeData = [];
			}
            params = { 
               'msid': this.msid,
               'uid': this.properties.uid,
               'ssid': this.ssid,
               'samples': thisData,
            }
            for(let i in this.orderHeader){
               sendKey = this.orderHeader[i].columnCode;
               sendValue = this.orderData[this.orderHeader[i].columnCode];

				if(this.orderData[this.orderHeader[i].columnCode] != this.dafaultOrderData[this.orderHeader[i].columnCode]){
					this.boolChange = true;
				}

				if(sendValue){
					params[sendKey] = sendValue
				}
            }   
				// if(this.boolChange){
				// 	this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
				// 	.then(res=>{
				// 		sessionStorage.setItem('uid',res.data.uid);
				// 		this.properties.uid = res.data.uid;

				// 		this.isLoading = false;
				// 		if (evt) {
				// 			this.$router.go({name:this.$route.name});
				// 		} else {
				// 			this.confirmData();
				// 		}
				// 	})
				// 	.catch(err=>{
				// 		if(err){
				// 			alert('The system failed and the save failed. Please contact your system administrator.');
				// 		}						
				// 		console.log(err)});
				// }else{
				// 	this.isLoading = false;
				// 	alert('No data has been changed. Can not save.');
				// 	return false;
				// }
			},
		
			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true
				setTimeout(() => {
					this.isLoading = false
				}, 10 * 100)
			},
			/*
			* Experiment Data Check All
			*/
			async checkAll(){
				const checkRow = this.$refs.sheet.hotInstance.getData();
				if(this.isCheckAll){
					this.isCheckAll = false;
				}else{
					this.isCheckAll = true;
				}
				this.sampleData.forEach(a => {
					a[0] = this.isCheckAll;
				});
				this.rendertab();
			},
			  /*
			* Experiment Data Change Arrary Insert
			*/
			async changeData(source){
				if(this.$refs.sheet.hotInstance){
                    this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
				}
				if(arguments[1] === 'edit' || arguments[1] === 'Autofill.fill'){ //문제 없음
					//arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
                    if(arguments[0][0][3] != arguments[0][0][0]){ //DNA에서는 일로 탐
                        this.boolChange = true;
                    }else{
                        if (Number(arguments[0][0][1]) > 2) {
                            if (this.defaultSampleData) {
                                if(arguments[0][0][3] != this.defaultSampleData[arguments[0][0][0]][Number(arguments[0][0][1])-1]){
                                    this.boolChange = true;
                                }else{
                                    this.boolChange = false;
                                }
                            } else {
                                this.boolChange = true;
                            }
						} else {
							 this.boolChange = true;
						}
						
					}
                } else if (arguments[1] === 'loadData') { //sample add 후 아무 동작 안하고 save할시에 
					if (this.sampleChangeData) {
							this.boolChange = true;
					} else {
						if (arguments[0]) {
							this.boolChange = true;
						} else {
							this.boolChange = false;
						}
					}
				}
			},
			async classifyWorkChange(mid) {
				this.re_orderId = mid;
				if (this.properties.mid === mid) {
					this.reOrderButtons = true;
				} else {
					this.reOrderButtons = false;
				}
				this.classifyPreDefaultData();
		 	},
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			preSampleSetting() {
				return this.classifyPreSampleHeader;
			},
			preSetting() {
				return this.classifyPreHeader;
			},
		},
		watch: {
			checkedRows: function() {
				// 상위 테이블 선택 한경우 this.checkedRowData에 무조건 Insert
				const validVisibleData = this.$refs.table.visibleData.filter((row, idx) => {
					if(this.$refs.table.isRowChecked(row)){
						this.checkedRowData = this.checkedRowData.concat(common.makeData(this.preDefaultSampleData[idx], 1, this.addData));
						common.a_overlap_c(this.checkedRowData);
					}else{
						let data = common.makeData(this.preDefaultSampleData[idx], 1, this.addData);
						data = data.filter((s_row, s_idx)=>{
							for(let i in this.checkedRowData){
								if(this.checkedRowData[i].hasOwnProperty('detailId') && s_row.hasOwnProperty('detailId')){
									if(this.checkedRowData[i].detailId === s_row.detailId){
										this.checkedRowData.splice(i, 1);
									}
								}else{
									if(this.checkedRowData[i].sampleId === s_row.sampleId){
										this.checkedRowData.splice(i, 1);
									}
								}

							}
						});
					}
				});
				// 하위 테이블 데이터 새로 고침
				this.classifyPreSampleData();

            },
          
			sampleCheckedRows: function(){
				// 하위 데이터가 모조건 전체 선택인 경우 실행 (현재 기준 19.08.29 15시)
				for(let i in this.$refs.table.visibleData){ 
					// 하위 sample 데이터의 갯수에 따른 상위 데이터 체크 박스 해제 기능
					if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[i])){ // 상위 테이블 체크 여부 확인
						if(this.preSampleData.length > this.sampleCheckedRows.length){ // sample 데이터와 sample 체크 데이터 비교 조건
							for(let i in this.$refs.table.newCheckedRows){ // 상위 체크 데이터 loop
								if(this.preSampleData[0].gid === this.$refs.table.newCheckedRows[i].id){ // sample 데이터의 gid와 상위 체크 데이터 같은 경우 상위 데이터 splice
									this.$refs.table.newCheckedRows.splice(i, 1);
								}
							}
						}
					}
					// 하위 테이블 체크 박스 모두 선택 인 경우 상위 테이블의 체크 박스 추가 기능
					if(event.path[7].id === 'preSampleTable'){ // 하위 체크 박스 선택 여부 확인 (event로 구분했음 향후 변경 필요 함)
						if(this.$refs.sampleTable.isAllChecked){ // 하위 테이블의 체크 박스 전체 선택 여부 확인
							if(this.preSampleData[0].gid === this.$refs.table.visibleData[i].id){ // sample 데이터와 sample 체크 데이터 비교 조건
								this.$refs.table.newCheckedRows.push(this.$refs.table.visibleData[i]); // 없는 경우 추가
							}
						}
					}
				}
				// Add 데이터 생성
				this.checkedRowData = this.checkedRowData.concat(this.sampleCheckedRows); // 전체 넣기
				common.a_overlap_c(this.checkedRowData); // 중복 제거 common make function
				if(this.sampleCheckedRows.length != this.preSampleData.length){ // 전체 아닌 경우 Add 데이터 생성
					if(event.path[7].id === 'preSampleTable'){ // preSampleTable의 이벤트를 체크 (단 event의 path값 변경되면 수정 해주어야 함)
						let checkedIdx = [];
						this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
							this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
								// detailId key가 없는 경우 비교
								if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
									if(a.detailId === c.detailId){
										if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}else{
									if(a.sampleId === c.sampleId){
										if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}
								return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
							});
							return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						checkedIdx.sort((a,b)=>{return b - a}) // 해당 변수를 역순으로 sort
						if(checkedIdx.length > 0){ // 이부분이 중요. 아래 조건문의 splice 는 해당 배열 값을 삭제 한다. 단 순차적으로 삭제하면 삭제한 row가 없어져 에러가 난다 (아래 계속)
							for(let i in checkedIdx){ // (아래 계속) 그래서 역순으로 정렬하여 배열의 마지막 값 부터 삭제 한다. 간단하지만 꼭 기억해야함.
								this.checkedRowData.splice(checkedIdx[i], 1);
							}
						}
					}
				}
				// // 개별 선택 체크 박스를 true로 바꾸는 작업
				if(this.sampleCheckedRows.length === 0 && this.checkedRowData.length > 0){
					this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
						this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									this.sampleCheckedRows.push(c);
								}
							}else{
								if(a.sampleId === c.sampleId){
									this.sampleCheckedRows.push(c);
								}
							}
							return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return..
					});
				}
			}
		},
	}

</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Order/DetailForm.vue